module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Ссылка (URL) <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.url\"/></td>\n		</tr>\n		<tr>\n			<td>Протокол (http, ftp и т.д.)</td>\n			<td><control type=\"text\" target=\"item.protocol\"/></td>\n		</tr>\n		<tr>\n			<td>Профиль приложения</td>\n			<td><control type=\"text\" target=\"item.appprofile\"/></td>\n		</tr>\n		<tr>\n			<td>Наименование</td>\n			<td><control type=\"text\" target=\"item.name\"/></td>\n		</tr>\n		<tr>\n			<td>Описание возможностей</td>\n			<td><control type=\"text\" target=\"item.description\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}